import { useAdminToken } from '@/hooks';
import { AdminLogout, Logout } from '@/utils/common';
import { showToast } from '@/utils/toastMessage/ToastMessage';
import { useToast } from '@/context/ToastContext';
import axios from 'axios';
import Cookies from 'js-cookie';
import { decryptData, encryptData } from '@/components/reusable/crypto/Cipher';

// import { handleError } from './crud/handleError'

const setUpSuperAdminInterceptor = () => {
  const API = axios.create({
    baseURL: import.meta.env.VITE_APP_API_URL,
    timeout: 60000,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  let isRefreshing = false;
  let failedQueue = [];
  let refreshPromise = null;

  const processQueue = (error, token = null) => {
    failedQueue.forEach((promise) => {
      if (error) {
        promise.reject(error);
      } else {
        promise.resolve(token);
      }
    });
    failedQueue = [];
  };

  /**
   * intercept api before hitting the api config the above settings
   */
  API.interceptors.request.use(
    (config) => {
      const token = useAdminToken();

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  API.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalRequest = error?.config;


      if (
        error.response?.status === 401 &&
        error.response?.data?.ResponseCode === '40101' 
      ) {
        originalRequest._retry = true;

        if (!refreshPromise) {
          const refreshToken = decryptData(Cookies.get('refreshToken'));

          refreshPromise = axios
            .post(`${import.meta.env.VITE_APP_API_URL}/auth/refresh/`, {
              refreshToken,
            })
            .then((res) => {
              const newToken = res.data.access;
              Cookies.set('token', encryptData(newToken), { expires: 7 });
              return newToken;
            })
            .catch((err) => {
              AdminLogout();
              throw err;
            })
            .finally(() => {
              refreshPromise = null;
            });
        }

        const newToken = await refreshPromise;
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return API(originalRequest);
      }

      if (error?.response?.status === 401) {
        const errMessage = error.response.data.response;
        showToast(errMessage, 'error');
        sessionStorage.clear();
        Object.keys(Cookies.get()).forEach(function (cookieName) {
          var neededAttributes = {
            // Here you pass the same attributes that were used when the cookie was created
            // and are required when removing the cookie
          };
          Cookies.remove(cookieName, neededAttributes);
        });

        setInterval(() => {
          window.location.replace('/admin/login/');
        }, 2000);
        return;
      }

      if (error?.response?.status === 403) {
        const errMessage = error.response.data.detail;
        showToast(errMessage, 'error');
        setInterval(() => {
          window.location.replace('/permission/denied/');
        }, 2000);
      }

      if (error?.response?.status === 400) {
        error?.response?.data?.error?.map((eachError) =>
          showToast(eachError, 'error'),
        );
      }

      if (error.code === 'ECONNABORTED') {
        showToast('Request Timeout', 'error');
      } else if (!navigator.onLine) {
        showToast(
          'No Internet Connection. Please check your internet connection',
          'error',
        );
      } else {
        return Promise.reject(error);
      }
    },
  );

  return API;
};
const API = setUpSuperAdminInterceptor();
export { API, setUpSuperAdminInterceptor };
